import styled from 'styled-components';

export const FetchingLabel = styled.span`
  color: #999;
  font-size: 14px;
  margin-top: -6px;
  padding: 3px;
`;

export const Content = styled.div`
  background-color: #fff;
  padding: 18px 30px 30px 30px;
  border-radius: 3px;
  width: 500px;
  height: 100%;
  overflow-y: auto;

  @media screen and (max-width: 1024px) {
    width: 100vw;
    height: 100%;
    overflow-y: auto;
  }
`;

export const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h4`
  display: block;
  color: #495057;
  font-weight: 700;
  font-size: 24px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  & > *:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const FormRow = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
`;

export const FormGroup = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const CheckboxWrapper = styled.div`
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;

  & > label {
    font-size: 10px;
    margin-top: -7px;
  }
`;

export const LastUsageLabel = styled.span`
  font-size: 14px;
  color: #999;
`;

export const BirthdayLabel = styled.span`
  color: #1976d2;
  font-size: 12px;
  font-weight: bold;
`;
